import React from 'react';
import { apiAuthCaller } from '@services/apiCaller';
import useStores from '@stores/useStores';
import { Skeleton } from 'antd';
import Table from '@ui-library/table';
import ErrorModal from '@ui-library/modal/error';
import { FixMe } from '@utils/types';
import { convertToHourlyUTC } from '@components/sources/visualizer/mappingScreens/sourceUtil';
import { getApiErrorMessage } from '@components/common/util/util';
import { IReportError } from './ReportError';
import ReportErrorsView from './ReportErrorsView';
import SampleView from './SampleView';
import ErrorMessageView from './ErrorMessageView';

export interface UnsuccessfulEventErrorProps {
  jobRunId: string;
  taskRunId: string;
  type: 'sources' | 'server';
  startedAt: string;
}

interface ReportErrorsModalViewProps extends UnsuccessfulEventErrorProps {
  sourceId: string;
  onClose: () => void;
}
const removeColumns = ['rudder_invalid', 'rudder_snapshot_id', 'rudder_snapshot_run_at'];

const ReportErrorsModalView = (props: ReportErrorsModalViewProps) => {
  const { sourceId, jobRunId, taskRunId, type, onClose, startedAt } = props;
  const [loading, setLoading] = React.useState(false);
  const [mode, setMode] = React.useState<'sample' | 'errors'>('errors');
  const [sample, setSample] = React.useState<FixMe>({});
  const [reportErrors, setReportErrors] = React.useState<IReportError[]>([]);
  const { userStore, messagesStore, workspaceStore } = useStores();
  const sampleEventArray = sample?.data?.sampleEvent.invalid || [{}];
  const sampleColumns = Object.keys(sampleEventArray[0])?.reduce((accum: FixMe, key: string) => {
    if (!removeColumns.includes(key)) {
      const column = {
        title: key,
        dataIndex: key,
        key,
        render: (data: FixMe) => String(data),
      };
      accum.push(column);
    }
    return accum;
  }, []);
  React.useEffect(() => {
    setLoading(true);
    const url = `/reports/metrics?sourceId=${sourceId}&jobRunId=${jobRunId}&taskRunId=${taskRunId}&type=${type}&from=${convertToHourlyUTC(
      startedAt,
      'floor',
    )}&workspaceId=${workspaceStore.id}`;
    apiAuthCaller(userStore!.token)
      .get(url)
      .then((resp) => {
        setReportErrors(resp.data.errors);
        setLoading(false);
      })
      .catch((err) => {
        messagesStore.showErrorMessage(getApiErrorMessage(err, 'Failed to load samples'));
      });
  }, []);

  const getHeaderText = () => {
    let headerText = 'Invalid Records (Samples)';
    let subText = 'These samples records sent from the source were invalid.';
    if (type === 'server') {
      headerText = 'Rejected Records (Samples)';
      subText = 'These sample records were rejected by the destination.';
    }
    return { headerText, subText };
  };

  const { headerText, subText } = getHeaderText();
  const isSampleErrorMessage = mode === 'sample' && sample.view === 'error_view';

  let view = null;
  if (loading) {
    view = <Skeleton paragraph={{ rows: 1 }} />;
  } else if (mode === 'errors') {
    view = (
      <ReportErrorsView
        errors={reportErrors}
        type={type}
        onClickSample={(data: FixMe, view: string) => {
          setSample({ data, view });
          setMode('sample');
        }}
      />
    );
  } else if (isSampleErrorMessage) {
    view = (
      <ErrorMessageView
        errorMessage={sample.data.sampleResponse}
        errorCode={type !== 'sources' ? sample.data.statusCode : undefined}
      />
    );
  } else if (type === 'sources') {
    view = <Table columns={sampleColumns} dataSource={sampleEventArray} pagination={false} />;
  } else {
    view = <SampleView sample={sample} />;
  }
  return (
    <ErrorModal
      header={headerText}
      subHeader={subText}
      view={view}
      onClose={onClose}
      handleBackClick={() => setMode('errors')}
      showBackButton={mode !== 'errors'}
      clipboardContent={!isSampleErrorMessage && mode === 'sample' ? JSON.stringify(sample) : ''}
    />
  );
};

export default ReportErrorsModalView;
